export default "__VITE_ASSET__hI3$1rGc__"